export const esES_globalTips = {
  'global.title.notfound': 'Lo siento, la página que ha visitado no existe.',
  'global.title.backHome': 'Ir a Inicio',
  'global.title.error': 'Ha ocurrido un error, inténtelo más tarde.',
  'global.title.download': 'Descargar',
  'global.title.more.filter': 'Más filtros',
  'global.title.less.filter': 'Menos filtros',
  'global.title.clean.filter': 'Limpiar filtros',
  'global.title.notification': 'Notificación',
  'global.title.range.date': 'Rango de fecha',
  'global.title.search': 'Buscar',
  'global.title.media': 'Medios',
  'global.title.all.male': 'Todos',
  'global.title.all': 'Todas',
  'global.title.channel': 'Canal',
  'global.title.condition': 'Condición',
  'global.title.resolution': 'Resolución',
  'global.title.tags': 'Etiquetas',
  'global.title.device': 'Dispositivo',
  'global.title.host': 'URL de origen',
  'global.title.country': 'País',
  'global.title.city': 'Ciudad',
  'global.title.satisfaction': 'Satisfacción',
  'global.title.date': 'Fecha',
  'global.title.user': 'Usuario',
  'global.title.unknown': 'Desconocido',
  'global.title.interactions': 'Interacciones',
  'global.title.not.response': 'Sin respuesta',
  'global.title.actions': 'Acciones',
  'global.title.without': 'Sin',
  'global.title.with': 'Con',
  'global.title.today': 'Hoy',
  'global.title.yesterday': 'Ayer',
  'global.title.this.week': 'Esta semana',
  'global.title.last.week': 'Semana anterior',
  'global.title.last.30.days': 'Últimos 30 días',
  'global.title.this.month': 'Este mes',
  'global.title.last.month': 'Mes anterior',
  'global.title.this.quarter': 'Este trimestre',
  'global.title.last.quarter': 'Trimestre anterior',
  'global.title.this.year': 'Este año',
  'global.title.empty': 'No hay registros',
  'global.title.back': 'Volver',
  'global.title.spotter.title': 'Descubre el poder de tus datos con Spotter, tu analista con IA',
  'global.title.spotter.description': 'Con Spotter puedes descubrir insights haciendo preguntas directas sobre tus datos y recibir al instante respuestas claras, visualizaciones dinámicas y recomendaciones inteligentes.'
};
